import { render, staticRenderFns } from "./JsonImport.vue?vue&type=template&id=957f5160&"
import script from "./JsonImport.vue?vue&type=script&lang=js&"
export * from "./JsonImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports